import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Events } from 'ionic-angular';

import { GlobalsProvider } from '../../providers/globals/globals';

import { InfoPage } from '../info/info'
import { HomePage } from '../home/home'
import { ListPage } from '../list/list'
import { UrAddPage } from '../ur-add/ur-add'
import { UrListPage } from '../ur-list/ur-list'
import { MaplistPage } from '../maplist/maplist'
import { ZapisPage } from '../zapis/zapis'
import { Card2cardPage } from '../card2card/card2card'

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-main',
  templateUrl: 'main.html',
})
export class MainPage {

  showBtn: boolean = false;
  deferredPrompt;


  /*mpages: Array<{ name: string, component: any, icon: string }>;
  mrazd: Array<{ id1: string, id2: string }>;*/
  showitems: string = '0';
  items: any;
  error: string;
  news: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http,
    public events: Events,
    private iab: InAppBrowser,
  ) {

    if (navParams.get('from_menu') == '2') this.itemsShow();

    this.http.get(this.params.apiURL + '?act=list-ans-reqs-not-viewed&id_user='+ + this.params.id_user)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          this.params.new_ans = data.count;
          console.log('this.params.new_ans = '+this.params.new_ans);
        },
        err => {
          this.error = "1";
          console.log('this.params.new_ans = err');
        }

    );  
    
    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });    

    loadingPopup.present();
    //console.log(this.params.apiURL + '?act=info&id_lang=' + this.params.id_lang);
    this.http.get(this.params.apiURL + '?act=info&id_lang=' + this.params.id_lang)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          //setTimeout(() => {
            //console.log(data);
            this.items = data.items;
            this.error = "0";

            loadingPopup.dismiss();

          //}, 1000);

        },

        err => {
          loadingPopup.dismiss();
          this.error = "1";
        }

    );

    //loadingPopup.present();

    this.http.get(this.params.apiURL + '?act=news&limit=2')
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
            this.news = data;
            this.error = "0";
        },

        err => {
          //loadingPopup.dismiss();
          this.error = "1";
        }

      );

    /*this.mrazd = [{ id1: '0', id2: '1' }, { id1: '2', id2: '3'}, { id1: '4', id2: '5' }];

    this.mpages = [
      { name: 'Полезная информация', component: InfoPage, icon: 'icon-info.png' },
      { name: 'Общение и знакомства', component: DatingPage, icon: 'icon-dating.jpg' },
      { name: 'Консультация юриста', component: UrTabsPage, icon: 'icon-law.png' },
      { name: 'Консультация врача', component: MedTabsPage, icon: 'icon-doctor.png' },
      { name: 'Работа и полезные ссылки', component: LinksPage, icon: 'icon-link.png' },
      { name: 'Новости', component: ListPage, icon: 'icon-consult.png' }
    ];*/

  }
  /*ionViewWillEnter() {
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later on the button event.
      this.deferredPrompt = e;

      // Update UI by showing a button to notify the user they can add to home screen
      this.showBtn = true;
    });

    //button click event to show the promt

    window.addEventListener('appinstalled', (event) => {
      //alert('installed');
    });


    if (window.matchMedia('(display-mode: standalone)').matches) {
      //alert('display-mode is standalone');
    }

  }

  add_to_home() {
    this.showBtn = false;
    // hide our user interface that shows our button
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          //alert('User accepted the prompt');
        } else {
          //alert('User dismissed the prompt');
        }
        this.deferredPrompt = null;
      });
  };*/

  changemenu() {
    //this.events.publish('chmenu');
    this.navCtrl.push(UrListPage, {
      id_show: '18'
    });    
  }

  openCons() {
    this.navCtrl.push(UrAddPage);
  }

  openZapis() {
    this.navCtrl.push(ZapisPage);
  }

  openCard2Card() {
    /*this.navCtrl.push(Card2cardPage);*/
    const options: InAppBrowserOptions = {
      zoom: 'no'
    }        
    const browser = this.iab.create('http://abbmigrants.ru', '_self', options);
    browser.show();    
  } 


  oneShow(item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(ListPage, {
      item: item
    });
  }

  openNews() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(ListPage);
  }

  openMap() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(MaplistPage);
  }

  itemShow(item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(InfoPage, {
      id: item.id
    });
  }

  itemsShow() {
    if (this.showitems == '0') this.showitems = '1'; else this.showitems = '0';
  }

  OpenPage(item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.setRoot(item.component);
  }

  Exit() {
    window.localStorage.clear();
    this.params.uuid = '';
    this.params.id_user = '';
    this.params.id_lang = '';
    this.params.token = '';
    this.navCtrl.setRoot(HomePage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MainPage');
  }

  ionViewWillEnter() {
    this.params.stat('main');    
  }     

}



// WEBPACK FOOTER //
// ./src/pages/main/main.ts